module.exports = __webpack_public_path__ + "img/0-111.4442d3e8.jpg";